import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { PostHogProvider } from "posthog-js/react";

const posthogOptions = {
	api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

// replace console.* for disable log on production
if (process.env.NODE_ENV === "production") {
	console.log = () => {
		//test
	};
	console.error = () => {
		//test
	};
	console.debug = () => {
		//test
	};
	console.warn = () => {
		//test
	};
}

ReactDOM.render(
	<React.StrictMode>
		<PostHogProvider
			apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
			options={posthogOptions}
		>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</PostHogProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// serviceWorker.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
